import { NotificationManager } from 'react-notifications';

const minWidth = 512;
const minHeight = 512;


export const imageSizeValidator = (files, callback, closeModal) => {
  if (files.length) {
    const _URL = window.URL || window.webkitURL;
    const image = new Image();

    image.src = _URL.createObjectURL(files[0]);

    return image.onload = function() {
      const imgWidth = this.width;
      const imgHeight = this.height;

      if (imgHeight < minHeight || imgWidth < minWidth) {
        NotificationManager.error(`Min image size should be 512 x 512 pixels`, 'File upload', 4000);
        closeModal();
        return false;
      }

      callback(files);
      return true;
    }
  } else {
    NotificationManager.info('Please choose a file to upload', 'File upload', 3000);
    return false;
  }
};
